(() => {
  const configNode = document.getElementById('EEVShopConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const t = config.strings;
  const norm = value => String(value || '').toUpperCase().replace(/-FGXX$/, '').replace(/[^A-Z0-9]/g, '');
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:config.currency }).format(value / 100);
  const parameters = new URLSearchParams(location.search);
  const preview = parameters.get('preview_theme_id');
  const withPreview = path => {
    const url = new URL(path, location.origin);
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  };
  const shopUrl = (family, kind = 'light') => {
    const url = new URL('/collections/baja-designs', location.origin);
    if (family) url.searchParams.set('family', family);
    if (kind === 'harness') url.searchParams.set('kind', kind);
    return withPreview(url);
  };
  const variantUrl = (group, variant) => withPreview('/products/' + variant.handle + '?variant=' + variant.id + '&eev_group=' + encodeURIComponent(group.key));
  const liveVariants = new Map();
  const loadCatalog = async () => {
    const response = await fetch(config.catalogUrl);
    if (!response.ok) throw new Error('Catalog metadata unavailable');
    const catalog = await response.json();
    let next = config.dataUrl;
    const seen = new Set();
    while (next) {
      const url = new URL(withPreview(next), location.origin);
      url.searchParams.set('section_id', 'eev-catalog-data');
      if (seen.has(url.href)) throw new Error('Catalog pagination repeated');
      seen.add(url.href);
      const dataResponse = await fetch(url);
      if (!dataResponse.ok) throw new Error('Live prices unavailable');
      const doc = new DOMParser().parseFromString(await dataResponse.text(), 'text/html');
      const dataNode = doc.querySelector('[data-eev-live-catalog]');
      if (!dataNode) throw new Error('Catalog data missing');
      const data = JSON.parse(dataNode.textContent);
      for (const product of data.products) for (const variant of product.variants) {
        liveVariants.set(String(variant.id), { ...variant, image:product.image, handle:product.url.split('/').pop() });
      }
      next = data.next;
    }
    catalog.groups = catalog.groups.map(group => ({ ...group, variants:group.variants.flatMap(variant => {
      const live = liveVariants.get(String(variant.id));
      return live && norm(live.sku) === norm(variant.sku) ? [{ ...variant, ...live, id:String(live.id), options:variant.options }] : [];
    }) })).filter(group => group.variants.length);
    return catalog;
  };
  const sortedVariants = group => [...group.variants].sort((a,b) => Number(b.available) - Number(a.available) || a.price - b.price);
  const minPrice = group => Math.min(...group.variants.map(v => v.price));
  const card = (group, label, url, caption) => {
    const variant = sortedVariants(group)[0];
    const article = document.createElement('article');
    article.className = 'eev-product-card';
    const image = variant.image || group.image;
    article.innerHTML = '<a href="' + esc(url || variantUrl(group,variant)) + '"><div class="eev-product-card-art">' + (image ? '<img src="' + esc(image) + '" width="500" height="500" loading="lazy" alt="' + esc(label || group.title) + '">' : '') + (group.variants.every(v => !v.available) ? '<span class="eev-stock-label">' + esc(t.sold_out) + '</span>' : '') + '</div><div class="eev-product-card-copy"><span class="eev-store-eyebrow">Baja Designs</span><h3>' + esc(label || group.title) + '</h3><p class="eev-card-options">' + esc(caption || (group.variants.length + ' ' + t.configurations)) + '</p>' + (!label ? '<p class="eev-card-sku">' + esc(t.sku + ' ' + variant.sku) + '</p>' : '') + '<div class="eev-product-card-price"><span>' + esc((group.variants.length > 1 || label ? t.from + ' ' : '') + money(minPrice(group))) + '</span><span aria-hidden="true">↗</span></div></div></a>';
    return article;
  };
  const renderShop = catalog => {
    const grid = document.getElementById('EEVShopGrid');
    if (!grid) return;
    const input = document.getElementById('EEVShopTerm');
    const sort = document.getElementById('EEVShopSort');
    let selectedFamily = catalog.families.includes(parameters.get('family')) ? parameters.get('family') : '';
    let kind = parameters.get('kind') === 'harness' ? 'harness' : 'light';
    input.value = parameters.get('q') || '';
    const heading = document.getElementById('EEVShopHeading');
    const counts = document.getElementById('EEVResultCount');
    const nav = document.getElementById('EEVFamilyNav');
    const draw = () => {
      const search = input.value.trim().toLowerCase();
      document.querySelectorAll('[data-eev-kind]').forEach(link => {
        const active = link.dataset.eevKind === kind;
        link.toggleAttribute('aria-current', active);
        if (active) link.setAttribute('aria-current','page');
        link.href = shopUrl('', link.dataset.eevKind);
      });
      nav.replaceChildren();
      for (const family of ['',...catalog.families]) {
        const count = catalog.groups.filter(g => g.kind === kind && (!family || (kind === 'light' ? g.family === family : g.compatibleFamilies.includes(family) || (family === 'Squadron' && g.compatibleFamilies.includes('Squadron 2.0'))))).length;
        if (!count) continue;
        const link = document.createElement('a');
        link.href = shopUrl(family,kind);
        link.innerHTML = esc(family || t.all_families) + '<span>' + count + '</span>';
        if (selectedFamily === family) link.setAttribute('aria-current','page');
        nav.append(link);
      }
      let groups = catalog.groups.filter(g => g.kind === kind && (!selectedFamily || (kind === 'light' ? g.family === selectedFamily : g.compatibleFamilies.includes(selectedFamily) || (selectedFamily === 'Squadron' && g.compatibleFamilies.includes('Squadron 2.0')))));
      if (search) groups = groups.flatMap(g => {
        if (g.title.toLowerCase().includes(search)) return [g];
        const variants = g.variants.filter(v => (v.sku + ' ' + Object.values(v.options).join(' ')).toLowerCase().includes(search) || (norm(search).length > 2 && norm(v.sku).includes(norm(search))));
        return variants.length ? [{...g,variants}] : [];
      });
      if (sort.value === 'price-asc') groups.sort((a,b) => minPrice(a) - minPrice(b));
      if (sort.value === 'price-desc') groups.sort((a,b) => minPrice(b) - minPrice(a));
      if (sort.value === 'title') groups.sort((a,b) => a.title.localeCompare(b.title));
      grid.replaceChildren();
      const showFamilies = kind === 'light' && !selectedFamily && !search && sort.value === 'featured';
      if (showFamilies) {
        heading.textContent = t.choose_family;
        for (const family of catalog.families) {
          const models = groups.filter(g => g.family === family);
          if (!models.length) continue;
          const primary = [...models].sort((a,b) => Number(/Pair|White|Flush|Infrared/.test(a.title)) - Number(/Pair|White|Flush|Infrared/.test(b.title)))[0];
          const combined = { ...primary, variants:models.flatMap(g => g.variants) };
          const node = card(combined, family === 'XL' ? 'XL Series' : family, shopUrl(family), models.length + ' ' + (models.length === 1 ? t.model : t.models));
          node.classList.add('eev-family-card');
          grid.append(node);
        }
      } else {
        heading.textContent = [selectedFamily,kind === 'harness' ? t.harnesses : t.lights].filter(Boolean).join(' ');
        for (const group of groups) grid.append(card(group));
      }
      counts.textContent = groups.length + ' ' + (kind === 'light' ? t.models : t.harnesses.toLowerCase());
      if (!grid.children.length) grid.innerHTML = '<div class="eev-shop-status"><p>' + esc(t.no_results) + '</p><a href="' + esc(shopUrl('',kind)) + '">' + esc(t.clear) + '</a></div>';
      grid.setAttribute('aria-busy','false');
    };
    document.getElementById('EEVShopSearch').addEventListener('submit',event => { event.preventDefault(); draw(); });
    input.addEventListener('input',draw);
    sort.addEventListener('change',draw);
    draw();
  };
  const recommendedSkus = (group, selected) => {
    const title = group.title;
    if (/Squadron.*2\.0/.test(title)) return ['640055','640064','600047','640098'];
    if (group.family === 'LP4') return ['640188','640323','640324','640325'];
    if (group.family === 'LP6') return ['640172','640324','640325'];
    if (group.family === 'LP9') return /Sport/.test(title) ? ['640175','640189'] : /Pro/.test(title) ? ['640172','640325','640176'] : [];
    if (['S1','S2','Squadron'].includes(group.family)) return ['640117','640093','613607','640165'];
    if (group.family === 'S8' || group.family === 'OnX6') {
      const size = parseFloat(selected.options.Size);
      const maxSize = group.family === 'S8' ? 30 : 20;
      return [...(size > 0 && size <= maxSize ? ['640115'] : []),'640122','640094','640169'];
    }
    if (group.family === 'XL' && /Linkable/.test(title)) return ['640193','640194','640195','640190','640191','640192','640199','640200','640201'];
    if (group.family === 'XL' && /Pro|Sport/.test(title)) return ['640115','640119','640094','640169'];
    if (group.family === 'XL80') return ['640115'];
    if (group.family === 'RTL') return /RTL-S/.test(title) ? ['640134'] : /RTL-M/.test(title) ? [] : ['640116'];
    return [];
  };
  const renderProduct = catalog => {
    if (!config.current) return;
    const currentId = String(new URLSearchParams(location.search).get('variant') || config.current.variantId);
    const candidates = catalog.groups.filter(g => g.variants.some(v => v.id === currentId));
    const group = candidates.find(g => g.key === parameters.get('eev_group')) || candidates[0];
    if (!group) return;
    const selected = group.variants.find(v => v.id === currentId);
    const info = document.querySelector('.product__info-container');
    if (!info || !selected) return;
    document.body.classList.add('eev-scoped-product');
    const heading = info.querySelector('h1');
    if (heading) heading.textContent = group.title;
    const sku = info.querySelector('.product__sku');
    if (sku) sku.textContent = t.sku + ' ' + selected.sku;
    const description = info.querySelector('.product__description');
    if (description) {
      description.innerHTML = group.descriptionHtml;
      description.classList.add('eev-source-description');
    }
    const axes = [...new Set(group.variants.flatMap(v => Object.keys(v.options)))];
    const panel = document.createElement('div');
    panel.className = 'eev-config-panel';
    const label = document.createElement('h2');
    label.textContent = t.configure;
    panel.append(label);
    for (const axis of axes) {
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = axis === 'Color' ? t.lens_color : axis;
      const options = document.createElement('div');
      options.className = 'eev-config-options';
      for (const value of [...new Set(group.variants.map(v => v.options[axis]).filter(Boolean))]) {
        const wrapper = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'eev-' + axis;
        input.value = value;
        input.checked = selected.options[axis] === value;
        input.disabled = !group.variants.some(v => v.options[axis] === value && axes.every(key => key === axis || v.options[key] === selected.options[key]));
        const text = document.createElement('span');
        text.textContent = value;
        input.addEventListener('change', () => {
          const matches = group.variants.filter(v => v.options[axis] === value && axes.every(key => key === axis || v.options[key] === selected.options[key])).sort((a,b) => Number(b.available) - Number(a.available));
          if (matches[0]) location.assign(variantUrl(group,matches[0]));
        });
        wrapper.append(input,text);
        options.append(wrapper);
      }
      fieldset.append(legend,options);
      panel.append(fieldset);
    }
    const choice = document.createElement('p');
    choice.className = 'eev-config-selection';
    choice.textContent = t.selected + ' ' + Object.entries(selected.options).map(([key,value]) => key + ': ' + value).join(' · ');
    if (axes.length) panel.append(choice);
    const target = info.querySelector('variant-selects, product-form');
    if (target && axes.length) {
      target.before(panel);
      const native = info.querySelector('variant-selects');
      if (native) native.hidden = true;
    }
    if (group.kind !== 'light') return;
    const wiring = document.createElement('aside');
    wiring.className = 'eev-wiring-panel';
    const wiringHeading = document.createElement('h2');
    wiringHeading.textContent = t.wiring_for_family;
    const note = document.createElement('p');
    note.textContent = (/^yes/i.test(selected.options['Harness?'] || '') ? t.harness_included + ' ' : '') + t.wiring_note;
    wiring.append(wiringHeading,note);
    const wanted = recommendedSkus(group,selected);
    const matches = catalog.groups.filter(g => g.kind === 'harness' && g.variants.some(v => wanted.includes(norm(v.sku))));
    if (matches.length) {
      const grid = document.createElement('div');
      grid.className = 'eev-wiring-grid';
      for (const g of matches.slice(0,4)) grid.append(card(g,null,null,t.view_options));
      wiring.append(grid);
    } else {
      const message = document.createElement('p');
      message.textContent = t.no_wiring;
      wiring.append(message);
    }
    const link = document.createElement('a');
    link.href = shopUrl(group.family,'harness');
    link.textContent = t.all_wiring + ' ↗';
    wiring.append(link);
    info.append(wiring);
  };
  const start = () => loadCatalog().then(catalog => { renderShop(catalog); renderProduct(catalog); }).catch(() => {
    const grid = document.getElementById('EEVShopGrid');
    if (grid) {
      grid.innerHTML = '<div class="eev-shop-status"><p>' + esc(t.load_error) + '</p><button type="button">' + esc(t.retry) + '</button></div>';
      grid.setAttribute('aria-busy','false');
      grid.querySelector('button').addEventListener('click',start,{once:true});
    }
  });
  start();
})();
